import './mission.css';
import { Header } from "../../components/widgets/header/header";
import { smoothScroll } from "../index/smooth-scroll";

export function initMissionPage() {
  Header.init();
  smoothScroll.init();
}